import { render, staticRenderFns } from "./DrawerDriverStatements.vue?vue&type=template&id=0267de5f"
import script from "./DrawerDriverStatements.vue?vue&type=script&lang=js"
export * from "./DrawerDriverStatements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports